import { render, staticRenderFns } from "./WeightShowCreateEdit.vue?vue&type=template&id=16f11d17&scoped=true&"
import script from "./WeightShowCreateEdit.vue?vue&type=script&lang=js&"
export * from "./WeightShowCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f11d17",
  null
  
)

export default component.exports